import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';
import { isEmpty } from '@app/core/functions/isEmpty';
import { BootstrapThemeProp } from '@app/core/services/bootstrap-theme.service';
import { ExportsDataService } from '@app/exports/services/exports-data.service';
import { Modal } from '@app/modules/modals/modals.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, EMPTY, finalize, Subject, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'fdx-designated-hosts-modal',
    templateUrl: './designated-hosts-modal.component.html',
    standalone: false
})
export class DesignatedHostsModalComponent implements Modal, OnDestroy {
    private readonly unsubscribe$: Subject<void> = new Subject<void>();

    hasError: boolean = false;
    hosts: string[] = [];
    errorMessage: string = '';
    loading: boolean = false;
    modalTheme: BootstrapThemeProp = 'primary';

    constructor(
        private readonly exportsDataService: ExportsDataService,
        private readonly modal: NgbActiveModal
    ) { }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    onModalInit({ databaseId, url }: { databaseId: string; url: string; }): void {
        if (isEmpty(url)) {
            this.hasError = true;
            this.errorMessage = 'The field \'url\' cannot be empty';

            return;
        }

        this.loading = true;

        this.exportsDataService.getDesignatedHosts(databaseId, url)
            .pipe(
                tap(({data}) => {
                    this.hosts = data;
                }),
                catchError((error: HttpErrorResponse) => {
                    this.hasError = true;
                    this.errorMessage = error.message;
                    return EMPTY;
                }),
                finalize(() => {
                    this.loading = false;
                }),
                takeUntil(this.unsubscribe$)
        ).subscribe();
    }

    onModalSubmit(_event: MouseEvent): void {
        this.modal.close();
    }

    onModalCancel(_event: MouseEvent): void {
        this.modal.dismiss();
    }
}
